module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-light.woff2
// module id = sy+4
// module chunks = 0